import getCurrentWorkoutSetDataStartWorkoutSelector from '../get-current-set-data'
import getCurrentSetIndexWorkoutExerciseSelect from '../../../workout-exercise/redux/selectors/get-current-set-index'
import { createSelector } from 'reselect'

const getNextSetSelect = createSelector(
  getCurrentWorkoutSetDataStartWorkoutSelector,
  getCurrentSetIndexWorkoutExerciseSelect,
  (curSetData, curSetIndex) => {
    if (!curSetData) {
      return
    }
    return curSetData[curSetIndex + 1]
  }
)

export default getNextSetSelect
